<template>
  <section class="section section1">
    <div class="banner-container">
      <swiper :options="swiperOption" ref="mySwiper" >
        <swiper-slide v-for="item in list"  :style="{backgroundImage:'url(' + item + ')'}"></swiper-slide>
        <div class="swiper-pagination"  slot="pagination" v-show="list.length>1"></div>
        <div class="swiper-button-prev" slot="button-prev" v-show="list.length>1"></div>
        <div class="swiper-button-next" slot="button-next" v-show="list.length>1"></div>
      </swiper>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'homeSection1',

    data () {
      return {
        swiperOption: {
          autoplay: 30000,
          speed: 500,
          loop: false,
            // noSwiping : true,
            noSwipingClass : 'stop-swiping',
          pagination: '.swiper-pagination',
          grabCursor: false,
          paginationClickable: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
        },
        list:[],
        bannerData:{
          bannerList: [require('@/assets/images/mockImg/banner.jpg'),require('@/assets/images/mockImg/banner2.jpg'),require('@/assets/images/mockImg/banner3.jpg')],
          bannerList1: [require('@/assets/images/mockImg/e-banner.jpg'),require('@/assets/images/mockImg/e-banner2.jpg'),require('@/assets/images/mockImg/e-banner3.jpg')]
        }
      }
    },
    created () {
      this.list = this.$i18n.locale=='cn' ? this.bannerData.bannerList : this.bannerData.bannerList1
    },
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section1 .banner-container
    rela();width: 100%;height: 6.5rem;
    .banner-wrap
      height: 650px


  .swiper-container
    height: 6.5rem
    .swiper-slide
      bgCover();
      &:last-child{background-position:20% center}
    >>>.swiper-button-prev
      opacity 0;left 50px;width: 40px;height: 75px;background-repeat no-repeat;background-position center center;background-size 25.6px 48px;background-image url("~@/assets/images/home/banner-point-left.png")
    >>>.swiper-button-prev:hover
      background-color rgba(0,0,0,0.54)
    >>>.swiper-button-next
      opacity 0;right 50px;width: 40px;height: 75px;background-repeat no-repeat;background-position center center;background-size 25.6px 48px;background-image url("~@/assets/images/home/banner-point-right.png")
    >>>.swiper-button-next:hover
      background-color rgba(0,0,0,0.54)
    >>>.swiper-pagination-bullet
      width: 10px;height: 10px;border 1px solid $standardColor;background-color rgba(255,255,255,.75);opacity 1;
    >>>.swiper-pagination-bullet-active
      background-color $standardColor
  >>>.swiper-container:hover .swiper-button-prev,>>>.swiper-container:hover .swiper-button-next
    opacity 1

</style>
